import { Component, OnInit } from '@angular/core';
import { QrGeneratorNavigatorCategories } from 'shared-library';
import { QrGeneratorNavigatorSteps } from '@app/store/enums/qr-generator-navigator-steps.enum';
import { QrGeneratorNavigator } from '@app/store/models/qr-generator-navigator.interface';
import { SessionInfo } from '@app/store/models/session-info.interface';
import { Subscription } from 'rxjs';
import { CoreService } from 'src/app/modules/core/services/core.service';
import { FunctionsService } from 'src/app/modules/core/services/functions.service';
import { UserQrGeneratorService } from 'src/app/modules/user/services/user-qr-generator.service';

@Component({
  selector: 'app-shared-qr-preview-vcard',
  templateUrl: './shared-qr-preview-vcard.component.html',
  styleUrls: ['./shared-qr-preview-vcard.component.scss']
})
export class SharedQrPreviewVcardComponent implements OnInit {

  create_mode = !window.location.href.includes("edit")

  session_info: SessionInfo
  data: QrGeneratorNavigator
  private subscriptions: Subscription[] = []

  constructor(
    private coreService: CoreService,
    public functions: FunctionsService,
    private qrGeneratorService: UserQrGeneratorService
  ) {

    this.subscriptions.push(this.coreService.session_dataObservable.subscribe(si => {
      this.session_info = si

      let d: QrGeneratorNavigator
      if (this.create_mode) {
        d = this.session_info.qr_generating.drafts.find(d => d.selected_category == QrGeneratorNavigatorCategories.VCARD)
      } else {
        d = this.session_info.qr_generating.updating
      }

      if (d) {
        if (d.active_step === QrGeneratorNavigatorSteps.START) {
          // show demo data instead
          this.data = JSON.parse(JSON.stringify(d))
          this.data.vcard_data = this.qrGeneratorService.initVCardCategoryData()
          this.data.vcard_data.full_name = "Sarah"
          this.data.vcard_data.website = "brandqrcodes.com"
          this.data.vcard_data.designation = "Designer"
          this.data.vcard_data.mobile = "012 345 67891"
          this.data.vcard_data.email = "help@brandqrcodes.com"
          this.data.vcard_data.company_name = "Sarah Boutique"
          this.data.vcard_data.address = "Tennessee, United States"
          return
        }
        this.data = d
      }
    }));
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.subscriptions.map(s => s.unsubscribe())
  }


}
